{
  "meta": {
    "title": "Negocios",
    "manageAndSwitch": "Gestione y cambie entre sus negocios"
  },
  "actions": {
    "import": "Importar",
    "createBusiness": "Crear negocio",
    "createBusinessOrInstitution": "Crear negocio o institución",
    "createNewBusiness": "Crear nuevo negocio",
    "switchTo": "Cambiar a",
    "back": "Volver",
    "backToBusinesses": "Volver a negocios",
    "actions": "Acciones",
    "editBusiness": "Editar negocio",
    "deleteBusiness": "Eliminar negocio",
    "cancel": "Cancelar",
    "saveChanges": "Guardar cambios",
    "saving": "Guardando",
    "uploadingImage": "Subiendo imagen...",
    "makePrimary": "Marcar como principal",
    "makePrimaryConfirm": "¿Hacer de esta ubicación la ubicación principal de esta organización?",
    "makePrimarySuccess": "Ubicación principal actualizada",
    "makePrimaryError": "Error al actualizar",
    "view": "Ver"
  },
  "empty": {
    "noBusinessesYet": "Aún no hay negocios",
    "createFirstOrImport": "Cree su primer negocio o importe varios a la vez desde Excel.",
    "selectFromList": "Seleccione un negocio de la lista",
    "clickToViewDetails": "Haga clic en un negocio para ver sus detalles",
    "searchNoMatch": "Ningún negocio coincide con su búsqueda"
  },
  "labels": {
    "unnamedBusiness": "Negocio sin nombre",
    "unnamed": "Sin nombre",
    "branch": "Sucursal",
    "primary": "Principal",
    "noDescription": "Sin descripción",
    "noDescriptionAvailable": "Sin descripción disponible",
    "contactAndLocation": "Contacto y ubicación",
    "quickLinks": "Enlaces rápidos",
    "quickLinksDesc": "Gestione este negocio en toda la plataforma",
    "businessProfile": "Perfil del negocio",
    "services": "Servicios",
    "appointments": "Citas",
    "income": "Ingresos",
    "searchBusinessesPlaceholder": "Buscar negocios...",
    "noContactInfo": "Sin información de contacto",
    "moreFromBusiness": "Más de este negocio",
    "moreFromBusinessDesc": "Otras ubicaciones vinculadas a esta organización"
  },
  "columns": {
    "name": "Negocio",
    "industry": "Industria",
    "location": "Ubicación",
    "type": "Tipo"
  },
  "show": {
    "businessDetails": "Detalles del negocio",
    "businessNotFound": "Negocio no encontrado",
    "businessNotFoundDesc": "El negocio que busca no existe o ha sido eliminado.",
    "overview": "Resumen",
    "analytics": "Analítica",
    "settings": "Configuración",
    "createdOn": "Creado el {{date}}",
    "contactInfo": "Información de contacto",
    "contactInfoDesc": "Datos de contacto y ubicación del negocio",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "location": "Ubicación",
    "owner": "Propietario del negocio",
    "ownerDesc": "Información sobre el propietario del negocio",
    "financial": "Información financiera",
    "financialDesc": "Datos de cuenta bancaria para pagos",
    "bankName": "Nombre del banco",
    "accountNumber": "Número de cuenta",
    "fulfillmentRateTitle": "Tasa de cumplimiento de servicios",
    "fulfillmentRateDesc": "Porcentaje de servicios completados correctamente",
    "fulfillmentRate": "Tasa de cumplimiento",
    "reportsTitle": "Reportes",
    "reportsDesc": "Número total de reportes recibidos",
    "totalReports": "Total de reportes",
    "quickStats": "Estadísticas rápidas",
    "quickStatsDesc": "Resumen de métricas de rendimiento del negocio",
    "performance": "Rendimiento",
    "status": "Estado",
    "industry": "Industria",
    "active": "Activo",
    "blocked": "Bloqueado",
    "businessSettings": "Configuración del negocio",
    "businessSettingsDesc": "Gestione la configuración y preferencias del negocio",
    "businessStatus": "Estado del negocio",
    "currentStatus": "Estado actual: {{status}}",
    "approvalStatus": "Estado de aprobación",
    "approvalState": "Estado de aprobación del negocio",
    "editBusinessSettings": "Editar configuración del negocio",
    "viewDetailsDesc": "Ver información detallada de este negocio"
  },
  "edit": {
    "title": "Editar negocio",
    "description": "Actualice la información de su negocio",
    "businessInformation": "Información del negocio",
    "businessInformationDesc": "Actualice los datos de su negocio",
    "businessLogo": "Logo del negocio",
    "businessName": "Nombre del negocio",
    "businessNamePlaceholder": "Ingrese el nombre del negocio",
    "businessDescription": "Descripción del negocio",
    "businessDescriptionPlaceholder": "Describa su negocio",
    "industry": "Industria",
    "industryPlaceholder": "Seleccionar una industria",
    "industrySearchPlaceholder": "Buscar industrias...",
    "industryEmpty": "No se encontró ninguna industria",
    "businessEmail": "Correo del negocio",
    "businessEmailPlaceholder": "negocio@ejemplo.com",
    "businessPhone": "Teléfono del negocio",
    "businessPhonePlaceholder": "+1234567890",
    "locationRequired": "La ubicación es obligatoria",
    "updatedSuccess": "Negocio actualizado correctamente",
    "updateError": "Error al actualizar el negocio",
    "location": "Ubicación",
    "locationPlaceholder": "Buscar una dirección"
  },
  "create": {
    "title": "Crear negocio o institución",
    "branchTitle": "Agregar una nueva ubicación",
    "branchDescription": "Cree otra ubicación vinculada a {{name}}.",
    "chooseType": {
      "title": "¿Qué desea crear?",
      "description": "Elija si es un negocio independiente o una sucursal de uno existente.",
      "standaloneTitle": "Negocio independiente",
      "standaloneDescription": "Un negocio separado con su propia organización.",
      "branchTitle": "Sucursal / ubicación",
      "branchDescription": "Una nueva ubicación vinculada a {{name}}.",
      "branchDescriptionFallback": "Una nueva ubicación vinculada a su negocio actual.",
      "cancel": "Cancelar"
    },
    "descriptionPrefix": "Siga los pasos a continuación para crear su negocio o institución. ¿Necesita agregar varios?",
    "importViaExcel": "Importar vía Excel",
    "steps": {
      "infoTitle": "Información del negocio o institución",
      "infoDesc": "Ingrese la información básica de su negocio o institución",
      "locationTitle": "Ubicación y contacto",
      "locationDesc": "Agregue la ubicación y datos de contacto de su negocio o institución",
      "planTitle": "Elegir plan",
      "planDesc": "Seleccione Starter o Premium para su negocio",
      "documentsTitle": "Documentos",
      "documentsDesc": "Suba los documentos requeridos del negocio o institución"
    },
    "toasts": {
      "uploadFailedPrefix": "Error al subir:",
      "uploadDocFailed": "Error al subir el documento. Inténtelo de nuevo.",
      "uploadImageFailed": "Error al subir la imagen. Inténtelo de nuevo.",
      "createdSuccess": "Negocio o institución creado correctamente",
      "createError": "Error al crear el negocio o institución",
      "fillAllRequired": "Complete todos los campos obligatorios",
      "coordsNotFound": "No se pudieron encontrar coordenadas para esta dirección. Elija una sugerencia de la lista o verifique su dirección.",
      "uploadRequiredDoc": "Suba el documento requerido",
      "locationDenied": "Acceso a la ubicación denegado o no disponible"
    },
    "next": {
      "next": "Siguiente",
      "nextWithTitle": "Siguiente: {{title}}"
    }
  },
  "createSteps": {
    "ownerEmail": "Correo del propietario del negocio o institución",
    "ownerEmailPlaceholder": "propietario@ejemplo.com",
    "logo": "Logo del negocio o institución",
    "name": "Nombre del negocio o institución",
    "namePlaceholder": "Ingrese el nombre del negocio o institución",
    "description": "Descripción del negocio o institución",
    "descriptionPlaceholder": "Describa su negocio o institución",
    "industry": "Industria",
    "industryPlaceholder": "Seleccionar una industria",
    "industrySearchPlaceholder": "Buscar industrias...",
    "industryEmpty": "No se encontró ninguna industria",
    "whereLocated": "¿Dónde se encuentra su negocio o institución?",
    "location": "Ubicación",
    "locationHelp": "Comience a escribir su dirección y elija una sugerencia de la lista para establecer su ubicación exacta.",
    "locationPlaceholder": "p. ej. Calle Principal 123, Accra",
    "contactHeader": "¿Cómo podemos contactarlo?",
    "email": "Correo del negocio o institución",
    "phone": "Número de teléfono del negocio o institución",
    "documents": {
      "requirements": "Requisitos:",
      "pdfOnly": "Debe estar en formato PDF",
      "singlePdf": "Suba todos los documentos como un único PDF",
      "registrationDocs": "Debe contener documentos de registro e incorporación del negocio o institución",
      "ids": "Debe contener la Ghana Card o el pasaporte de dos directores del negocio o institución",
      "documentLabel": "Documento del negocio o institución"
    },
    "locationPermission": {
      "allowTitle": "¿Permitir acceso a la ubicación?",
      "failedTitle": "Error de acceso a la ubicación",
      "autoFillDesc": "Podemos completar automáticamente su ubicación para agilizar la configuración. Siempre puede editarla manualmente.",
      "tryAgainOrManual": "Puede intentarlo de nuevo o ingresar su dirección manualmente.",
      "enterManually": "Ingresar manualmente",
      "tryAgain": "Intentar de nuevo",
      "allowLocation": "Permitir ubicación",
      "detecting": "Detectando ubicación..."
    }
  },
  "import": {
    "title": "Importar negocios",
    "description": "Importe negocios en masa usando una plantilla de Excel",
    "templateDownloaded": "Plantilla descargada",
    "instructions": "Instrucciones",
    "downloadTemplate": "Descargar plantilla",
    "downloadTemplateHelp": "Obtenga la plantilla de Excel y complete los datos de su negocio según los encabezados de columna.",
    "downloadTemplateBtn": "Descargar plantilla",
    "uploadFilledTemplate": "Subir plantilla completada",
    "uploadFilledTemplateHelp": "Suba su archivo de Excel completado para importar negocios en masa.",
    "foundCount": "{{count}} negocio{{plural}} encontrado(s)",
    "importing": "Importando...",
    "importBtn": "Importar negocios",
    "parseNone": "No se encontraron filas de negocio válidas. Asegúrese de que el archivo tenga una fila de encabezado y al menos una fila con un nombre de negocio y teléfono.",
    "parseFailed": "Error al analizar el archivo de Excel. Verifique el formato del archivo.",
    "selectFileFirst": "Seleccione un archivo primero",
    "noValidBusinesses": "No se encontraron negocios válidos. Asegúrese de que cada fila tenga nombre y teléfono.",
    "importedSuccess": "Negocios importados correctamente",
    "importFailed": "Error al importar negocios",
    "requiredColumnsTitle": "Columnas obligatorias",
    "requiredColumnsDesc": "Su archivo de Excel debe incluir estas columnas:",
    "required": {
      "name": "Nombre del negocio (5–150 caracteres)",
      "phone": "Número de teléfono del negocio",
      "optional": "Opcional: descripción, industria, correo, ubicación, imagen, documento, latitud, longitud, parentBusiness (id de negocio existente)"
    }
  },
  "dialogs": {
    "createBusinessDialog": {
      "title": "Cree su negocio o institución",
      "description": "Para utilizar plenamente el sistema y acceder a todas las funciones como servicios, citas, gestión de ingresos y más, primero debe crear un negocio o institución.",
      "dontShowAgain": "No volver a mostrar",
      "dismiss": "Descartar"
    }
  }
}
